import { useState } from 'react'

/**
 * Convenience hook for common visibility states.
 *
 * @returns {{
 *   isVisible: boolean,
 *   setVisible: function,
 *   show: function,
 *   hide: function,
 *   toggleVisibility: function
 * }}
 */
function useVisibility() {
  const [isVisible, setVisible] = useState(false)

  const show = () => setVisible(true)
  const hide = () => setVisible(false)
  const toggleVisibility = () => setVisible(!isVisible)

  return {
    isVisible,
    setVisible,
    show,
    hide,
    toggleVisibility,
  }
}

export default useVisibility
